import React from 'react';

export type StatisticValueSize = 'small' | 'medium' | 'large';

export interface StatisticProps {
    label: string | React.ReactNode;
    value: string | number | React.ReactNode;
    sub?: string | React.ReactNode;
    accent?: string;
    valueSize?: StatisticValueSize;
    width?: string | number;
    minWidth?: string | number;
    padding?: string;
    align?: 'left' | 'center' | 'right';
    className?: string;
    style?: React.CSSProperties;
}

const VALUE_SIZE_CLASSES: Record<StatisticValueSize, string> = {
    small: 'text-[22px]',
    medium: 'text-[32px]',
    large: 'text-[40px]',
};

const ALIGN_CLASSES: Record<NonNullable<StatisticProps['align']>, string> = {
    left: 'items-start text-left',
    center: 'items-center text-center',
    right: 'items-end text-right',
};

const CONTAINER_CLASSES = 'flex flex-col gap-[3px]';
const LABEL_CLASSES =
    'text-[10px] font-semibold uppercase leading-none tracking-[0.06em] m-0 text-[var(--malachite-text-dimmed)]';
const VALUE_BASE_CLASSES =
    'font-bold leading-none tracking-[-0.01em] m-0 text-[var(--malachite-text-primary)]';
const SUB_CLASSES =
    'text-[11px] font-medium leading-[1.3] m-0 text-[var(--malachite-text-dimmed)]';

const Statistic: React.FC<StatisticProps> = ({
    label,
    value,
    sub,
    accent,
    valueSize = 'medium',
    width,
    minWidth,
    padding = '0 16px',
    align = 'left',
    className = '',
    style = {},
}) => {
    const containerClasses = `${CONTAINER_CLASSES} ${ALIGN_CLASSES[align]} ${className}`;
    const valueClasses = `${VALUE_BASE_CLASSES} ${VALUE_SIZE_CLASSES[valueSize]}`;

    return (
        <div
            className={containerClasses}
            style={{ width, minWidth, padding, ...style }}
        >
            <span className={LABEL_CLASSES}>{label}</span>
            <span
                className={valueClasses}
                style={accent ? { color: accent } : undefined}
            >
                {value}
            </span>
            {sub !== undefined && sub !== null && <span className={SUB_CLASSES}>{sub}</span>}
        </div>
    );
};

export default Statistic;
export { Statistic };
